import React from 'react';
import PropTypes from 'prop-types';
import { commifyNumber } from '../../../utils/utilities';

const quoteValues = ({ terrorPremium, basePremium, totalPremium, identityRecoveryPremium, totalPrimaryPremium }) => {
    return (
        <div className="h4">
            Base Premium <strong>${commifyNumber(basePremium || '0')}</strong> + TRIA&nbsp;
            <strong>${commifyNumber(terrorPremium || '0')}</strong> {identityRecoveryPremium > 0 ? <span>+ Identity Recovery Coverage&nbsp;
            <strong>${commifyNumber(identityRecoveryPremium || '0')}</strong></span> : <span></span> } =&nbsp;
            <strong className="text-info">${commifyNumber(basePremium + terrorPremium + identityRecoveryPremium || '0')}</strong>
        </div>
    );
};

export const QuoteBlock = ({ ratings, mainTitle }) => {
    return (
        <div className="h3">
            {mainTitle}

            {ratings.type === 'oi' ? quoteValues(ratings) : null}
        </div>
    );
};

QuoteBlock.propTypes = {
    ratings: PropTypes.object
};

export default QuoteBlock;
